import Vue from 'vue';
import VueNoty from 'vuejs-noty';
import VueProgressBar from 'vue-progressbar'
import * as Vuetable from 'vuetable-2';
import vSelect from 'vue-select';
import VueDatePicker from 'vuejs-datepicker';
import VuetablePaginatorBootstrap4 from "./components/shared/VuetablePaginatorBootstrap4";
import money from 'v-money';
import Vuelidate from 'vuelidate'
import FloatingVue from 'floating-vue'
import VModal from 'vue-js-modal'
import VueTour from 'vue-tour'

/**
 * Setup Vue authentication plugin
 */
import router from './router.js';
import axios from 'axios';
import jwtToken from './helpers/jwt-token';
import store from './stores/index';

// global useful functions
export let setAll = (obj, val) => Object.keys(obj).forEach(k => obj[k] = val);
export let setNull = obj => setAll(obj, null);
window.$ = window.jQuery = $;
window.axios = axios;

//Vue Tour
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

// Progress bar to show progress when switch page or axios load
Vue.use(VueProgressBar, {
    color: '#4990fa',
    failedColor: '#c73500',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
});

//modal
Vue.use(VModal)

// Vue money
Vue.use(money, {precision: 2})

// Vue notification pop up
Vue.use(VueNoty, {
    progressBar: false,
    layout: 'bottomRight',
    theme: 'bootstrap-v4',
    timeout: 3000
});

// vue select
Vue.component('v-select', vSelect);
//
// // Avatar compoennt
// Vue.component('avatar', Avatar);

// registers vuetable globally
Vue.use(Vuetable)

Vue.use(VuetablePaginatorBootstrap4);

// datepicker
Vue.use(VueDatePicker)

// Validation
Vue.use(Vuelidate)

// Tooltips
Vue.use(FloatingVue)
//
// window.changeCarbonDate = (date) =>
// {
//     if (window.Laravel.env === 'testing')
//     {
//         console.log('calling carbon set time on'+date)
//         //axios post to set carbon
//         axios.post('/api/carbon/set', {date: date})
//           .then((res) => {
//               if(res.data.success) {
//                   console.log('changed carbon date to '+date)
//                   document.querySelector( 'body' ).classList.add( 'carbon_now_'+date );
//               } else {
//                   console.log('denied to change carbon date to '+date)
//               }
//           })
//           .catch((err) => {
//               console.log('failed carbon date to '+date)
//           })
//     } else {
//       console.log('not testing for '+date)
//     }
// }


// Axios setup
axios.interceptors.request.use(config => {
    config.headers['X-CSRF-TOKEN'] = window.Laravel.csrfToken;
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    if (window.Laravel.env === 'testing' && window.localStorage.getItem('carbon-date')) {
        config.headers['Carbon-Date'] = window.localStorage.getItem('carbon-date');
    }

    app.$Progress.start(); // for every request start the progress
    if (jwtToken.getToken()) {
        config.headers['Authorization'] = 'Bearer ' + jwtToken.getToken();
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// Axios response token verification
axios.interceptors.response.use(response => {
    app.$Progress.finish(); // finish when a response is received
    return response;
}, error => {

    app.$Progress.finish(); // finish when a response is received

    let errorResponseData = error.response;

    if (errorResponseData.data && errorResponseData.statusText === "Unauthorized" && errorResponseData.status === 401 ) {
        store.dispatch('unsetAuthUser')
            .then(() => {
                jwtToken.removeToken();
                router.push({name: 'login'});
            });
    }

    return Promise.reject(error);
});


// layouts
Vue.component('default-layout', require('./components/layouts/Default.vue').default);
Vue.component('guest-layout', require('./components/layouts/Guest.vue').default);
Vue.component('empty-layout', require('./components/layouts/Empty.vue').default);

// create Vue app
import App from './components/Master';
Vue.component('app', App);

import Formatter from './helpers/formatter';

Vue.mixin(Formatter);

// Filters
Vue.filter("numberComma", function(value) {
    if (value) {
        let parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    } else {
        return value;
    }
});

const app = new Vue({
    router,
    store
}).$mount('#app');

